export enum DictCodeEnmu {
    //客户类型
    CUSTOMER_TYPE = "customer-type",
    //名片属性
    CORD_TYPE = "card_type",
    //内部员工
    CORD_TYPE_STAFF = "card_type.staff"
}